// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"38f1b0af","46":"841ba2e2","79":"96ce408a","228":"309fde5a","238":"b1c563ee","453":"1826ebbf","637":"aaae0cb5","655":"e19ef3c7","727":"24277bcc","809":"88bdf79c"}[chunkId] + ".chunk.js";
};